import { shared, styled } from 'style'

export const InputStyled = styled('input', {
  ...shared.buttonReset,

  display: 'block',
  width: '100%',
  color: '$text1',
  bgc: '$bg2',
  border: '1px solid $bg3',
  borderRadius: '$lg',
  fontWeight: '$medium',
  outline: '2px solid $transparent',
  outlineOffset: '2px',
  transition: 'border-color .2s ease',
  cursor: 'text',

  '&::placeholder': {
    color: '$text4',
  },

  '&:focus': {
    outline: 'none',
    borderColor: '$text3',
  },

  '&:read-only': {
    cursor: 'text',
  },

  '&:disabled': {
    cursor: 'not-allowed',
    color: '$text3',
    bgc: '$bg2',
  },

  variants: {
    size: {
      sm: {
        padding: '$1-5',
        fontSize: '$sm',
        lineHeight: '$sm',
      },
      md: {
        padding: '$2-5',
        fontSize: '$sm',
        lineHeight: '$sm',
      },
      lg: {
        padding: '$3',
        fontSize: '$md',
        lineHeight: '$md',
      },
    },
    valid: {
      false: {
        bgc: '$bgError',
        borderColor: '$error',
      },
      true: {
        borderColor: '$success',
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
})
